import * as React from 'react';
import {
	Fragment,
	ReactNode,
	ReactText,
	useState,
} from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Button from '../button';
import Dialog from '../dialog';

import {
	GlobalStyle,
	ErrorLayout,
	ErrorContentLayout,
} from './styled';


export type ToastProps = {};

const Toaster: React.SFC<ToastProps> = () => {
	return (
		<Fragment>
			<GlobalStyle />
			<ToastContainer
				position='bottom-left'
				autoClose={3000}
				hideProgressBar={false}
				newestOnTop
				closeOnClick
				pauseOnFocusLoss
				draggable
				pauseOnHover
			/>
		</Fragment>
	);
}

Toaster.displayName = 'Toaster';
Toaster.defaultProps = {};

type EmitToastOptions = {
	content: ReactNode;
	autoClose?: number;
	hideProgressBar?: boolean;
	closeOnClick?: boolean;
	pauseOnHover?: boolean;
	draggable?: boolean;
	progress?: ReactText;
};

function emitToast(options: EmitToastOptions) {
	const { content, ...rest } = options;

	toast(content, {...rest});
}

function emitSuccessToast(options: EmitToastOptions) {
	const { content, ...rest } = options;

	toast.success(content, {...rest});
}

function emitWarningToast(options: EmitToastOptions) {
	const { content, ...rest } = options;

	toast.warning(content, {...rest});
}

export type ErrorContentProps = {
	content: ReactNode;
};

const ErrorContent: React.SFC<ErrorContentProps> = ({ content }) => {
	const [isOpen, setIsOpen] = useState(false);

	const handleOpen = () => setIsOpen(true);

	const handleClose = () => setIsOpen(false);

	return (
		<ErrorLayout>
			<div />
			<ErrorContentLayout>
				Что-то пошло не так 😢
			</ErrorContentLayout>
			<Button
				appearance='outlined'
				size='small'
				color='white'
				fullWidth
				onClick={handleOpen}>
				Показать детали ошибки
			</Button>
			<Dialog.Base isOpen={isOpen}>
				<Dialog.Header onClose={handleClose}>
					Детали ошибки
				</Dialog.Header>
				<Dialog.Content>
					{content}
				</Dialog.Content>
			</Dialog.Base>
		</ErrorLayout>
	);
}

ErrorContent.displayName = 'ErrorContent';
ErrorContent.defaultProps = {};

type EmitErrorToastOptions = {
	content: ReactNode;
	autoClose?: number;
	hideProgressBar?: boolean;
	closeOnClick?: boolean;
	pauseOnHover?: boolean;
	draggable?: boolean;
	progress?: ReactText;
};

const toastIDs = [];

function emitErrorToast(options: EmitErrorToastOptions) {
	const { content, ...rest } = options;

	if (toastIDs.length > 0) return;

	const toastID = toast.error(<ErrorContent content={content} />, {
		...rest,
		autoClose: false,
		hideProgressBar: true,
		closeOnClick: false,
		pauseOnHover: false,
		draggable: false,
		progress: undefined,
		onClose: () => {
			const idx = toastIDs.findIndex(x => x === toastID);

			if (idx !== -1) {
				toastIDs.splice(idx, 1);
			}
		}
	});

	toastIDs.push(toastID);
}

export {
	emitToast,
	emitSuccessToast,
	emitWarningToast,
	emitErrorToast,
};
export default Toaster;
